import * as types from '../mutation-types'
import vueCookie from 'vue-cookie'

// initial state
const state = {
  account: null,
  timeZone: window._timeZone,
}

// getters
const getters = {
  account: state => state.account,
  timeZone: state => state.timeZone,
}

// actions
const actions = {
}

// mutations
const mutations = {
  [types.ACCOUNT] (state, payload ) {
    payload.selectedMarket = null
    state.account = payload
    if(vueCookie.get(window.compcode + '_acc')){
      var accCookie = JSON.parse(vueCookie.get(window.compcode + '_acc'))
      state.account.oddsType = accCookie.oddsType
    }
    var account = _.cloneDeep(state.account)
    _.unset(account, 'gmSttng')

	  if(!vueCookie.get(window.compcode + '_acc') || !vueCookie.get(window.compcode + '_token') || 
      (state.account.currCL != '-' && state.account.currCL != JSON.parse(vueCookie.get(window.compcode + '_acc')).currCL) ||  
      state.account.oddsType != JSON.parse(vueCookie.get(window.compcode + '_acc')).oddsType || 
      btoa(account.acccode) != vueCookie.get(window.compcode + '_token')){
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          com_code: window.compcode,
          acc: JSON.stringify(account),
          tkn: btoa(account.acccode)
        },
      }).done((res) => {
        
      })
    }
    //vueCookie.set(window.compcode + '_acc', JSON.stringify(account))
    //vueCookie.set(window.compcode + '_token', btoa(account.acccode))
  },

  [types.SELECTED_ODD] (state, payload ) {
    var accCookie = JSON.parse(vueCookie.get(window.compcode + '_acc'))
    accCookie.oddsType = payload
    state.account = accCookie
    var account = _.cloneDeep(state.account)
    _.unset(account, 'gmSttng')
    // vueCookie.set(window.compcode + '_acc', JSON.stringify(account))

    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        com_code: window.compcode,
        acc: JSON.stringify(account),
      },
    }).done((res) => {
      
    })
  },
  TIME_ZONE (state, payload) {
    state.timeZone.default = payload
    var stkset = {
      default: payload,
      timeS: state.timeZone.list[payload][0],
      timeA: state.timeZone.list[payload][1],
      format:state.timeZone.format,
    }
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        action: 'timeZone',
        timeZoneSet: JSON.stringify(stkset),
        acc_code: state.account.acccode
      },
    }).done((res) => {
      
    })
  },
  [types.ACCOUNT_FAV] (state, payload ) {

      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          action: (payload.isFavLeague=='1') ? 'favLeagueEvent' : 'favEvent',
          fav: JSON.stringify(payload.favdt),
          acc_code: this.getters.account.acccode
        },
      }).done((res) => {
        
      })

  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/account.js